import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Title from "../components/Title";
import { CONTACT_PATH } from "../Routes/paths";
import { useNavigate } from "react-router-dom";
import Contact from "../components/Contact";

interface WebDesignProps {}

const WebDesign = ({}: WebDesignProps) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <Header />

      <main
        className={`w-full ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/* hero section  *****************************/}
        <Title
          title={t("Web Design")}
          subtitle={t("Services")}
          thirdTitle={t("Web Design")}
        />

        {/* next section  ******************************/}
        <section className="my-[20px] px-[20px] w-full flex flex-col items-center justify-center gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around ">
          <div>
            <img src="../images/webdesignintro.png" alt="" />
          </div>
          <div>
            <p
              className={`max-w-[800px] lg:text-[14px] text-center ${
                i18n.language === "en" ? "lg:text-left" : "lg:text-right"
              }`}
            >
              {t(
                "At Oxycom, we craft visually stunning and highly functional websites tailored to your unique business needs. Our expert team combines creativity with cutting-edge technology to deliver web designs that not only captivate your audience but also enhance user experience and drive engagement. Our team has years of experience creating award-winning websites across various industries and We stay ahead of the curve with the latest design trends, Transform your online presence with a website that stands out and drives results. Contact us today to start your web design journey with Oxycom."
              )}
            </p>
          </div>
        </section>

        {/* Our Values *********************************/}
        <section className="my-[100px] px-[20px] lg:px-[144px] 2xl:px-[180px] w-full flex flex-col gap-10 ">
          <p className="font-[700] text-[24px] lg:text-[28px] flex items-center justify-center">
            {t("Our “design philosophy” is simple")}
          </p>
          {/* grid section  *****************/}
          <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <p className="font-[700] text-[20px]">
                {t("Information First, Design Second")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "A successful website is rooted in its content. This methodology guarantees that the design serves to enhance and support the content."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("Do not make your site visitors think")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "we adhere to the principle of simplicity and clarity in web design, This approach leads to a seamless and enjoyable user experience."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("The simpler it is the better!")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "we believe that a streamlined, straightforward approach leads to better UX, our minimalist design philosophy can transform your online presence."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">{t("Responsive Design")}</p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Ensure your website looks and functions perfectly on any device with our expert Responsive Design, Our designs adapt seamlessly to all screen sizes."
                )}
              </p>
            </div>
          </div>
        </section>

        {/* Connect With Us: Your Voice Heard **************/}
        <Contact />
      </main>

      <Footer />
    </>
  );
};

export default WebDesign;
